import React from 'react';
import PropTypes from 'prop-types';
import {
  Platform,
  KeyboardAvoidingView,
  View,
  // RefreshControl,
  ActivityIndicator,
  Modal,
  TouchableOpacity,
  SafeAreaView,
} from 'react-native';
import {
  Button, Text, registerCustomIconType,
} from 'react-native-elements';
import { Formik } from 'formik';
import { useSharedValue } from 'react-native-reanimated';
import DraggableFlatList from 'react-native-draggable-flatlist';
import { object as yupObject } from 'yup';
import { compressToBase64, decompressFromBase64 } from 'lz-string';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

import { translate } from '../../../locales/i18n';
import AORTypes from '../../../types';
import styles from '../../../styles';
import {
  nameValidation,
  extraStayValidation,
} from '../../../modules/validation/Endpoint';
import App from '../../../modules/data/App';
import Endpoint from '../../../modules/data/Endpoint';
import PivotPointBadge from '../../apps/PivotPointBadge';
// import ScrollFading from '../../../../../misc/client/components/effects/ScrollFading';
// import { fixGoogleMapsWebStyles } from '../../../modules/Utils';

import miscConfig from '../../../config.json';

registerCustomIconType('font-awesome-5', FontAwesome5);

const validationSchema = yupObject().shape({
  name: nameValidation,
  extraStay: extraStayValidation,
});

const mapTypeMap = Platform.OS === 'web' ? 'roadmap' : 'standard';
const mapTypeSatellite = 'hybrid';

class PublisherLegForm extends React.Component {
  static getImage(image) {
    if (image.thumb) {
      return { uri: image.thumb };
    }

    const str = image.uuid;
    // FIXME(clairbee): why 8 6 4 2, and not 2 2 2 2 ???
    const prefix = str.substring(6, 8)
      + str.substring(4, 6)
      + str.substring(2, 4)
      + str.substring(0, 2);
    // const prefix = data.uuid.substring(0, 8);
    // console.log(prefix);
    let index = parseInt(prefix, 16) % 100;
    index += 100;
    index = index.toString().substr(-2, 2);

    return { uri: `https://${miscConfig.imagesThumbsBucket}.s3-${miscConfig.region}.amazonaws.com/${index}/${str}` };
  }

  constructor(props, context) {
    super(props, context);

    this.onRegionChangeComplete = this.onRegionChangeComplete.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleResetReal = this.handleResetReal.bind(this);
    // this.handleRefresh = this.handleRefresh.bind(this);

    this.state = {
      error: '',
      // refreshing: false,
      uploading: false,
      isResetting: false,
      // indexBeingDragged: -1,
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(_prevProps, _prevState) {
  }

  // handleRefresh() {
  //   const { onRefresh } = this.props;
  //   this.setState({ refreshing: true });

  //   onRefresh().then(() => {
  //     this.setState({ refreshing: false });
  //   });
  // }

  handleCancel(_values, _formikBag) {
    const { onCancel } = this.props;

    onCancel();
  }

  handleReset(_values, _formikBag) {
    this.setState({ isResetting: true });
  }

  handleResetReal() {
    const { onReset } = this.props;

    onReset();
  }

  handleSave(values, formikBag) {
    const {
      onSave, onCancel,
      getAnalyticsService,
    } = this.props;

    getAnalyticsService().report.event('legsEditAttempt', 'create');

    formikBag.setSubmitting(true);

    const vals = values;
    onSave(vals).then((result) => {
      console.log('result');
      console.log(result);
      getAnalyticsService().report.event('legsEditSuccess', 'create');
      onCancel();
    })
      .catch((err) => {
        formikBag.setStatus(err.message);
      });
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    // touched,
    // errors,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const {
      onReset,
      // onRefresh,
      app,
      endpoint,
      index,
      // history,
      direction,
      // getDirectionsService,
      // getAnalyticsService,
    } = this.props;
    const {
      // refreshing,
      uploading,
      mapType,
      isResetting,
    } = this.state;

    app.pp.legsManual = JSON.parse(decompressFromBase64(values.legsManual));
    // console.log('legs');
    // console.log(app.pp.legs);
    // console.log('legsManual');
    // console.log(app.pp.legsManual);

    const endpointsOrdered = [];
    // console.log('uuids to render:');
    app.pp.endpointIds.forEach((uuid) => {
      // console.log(uuid);

      for (let i = 0; i < app.pp.endpoints.length; i += 1) {
        if (app.data.endpoints[i].uuid === uuid) {
          endpointsOrdered.push(app.data.endpoints[i]);
          break;
        }
      }
    });

    const mapRadius = 20;
    if (Platform.OS === 'web') {
      // fixGoogleMapsWebStyles(direction);
    }

    const header = (
      <PivotPointBadge
        key="start"
        idx={-2}
        point={{
          name: translate('pivot_start'),
        }}
      />
    );
    const footer = (
      <PivotPointBadge
        key="end"
        idx={-1}
        point={{
          name: translate('pivot_finish'),
        }}
      />
    );

    return (
      <View style={{
        flex: 1,
        flexDirection: direction,
        width: '100%',
      }}
      >
        <View
          style={{
            flex: 1,
            width: '100%',
          }}
        >
          <div>Map was here</div>
          <View
            style={styles.map(direction).controlsTopRow}
          >
            <View style={styles.map(direction).controlContainer}>
              <Text
                style={styles.map(direction).mapTypeControl}
                onPress={() => {
                  this.setState({ mapType: mapType === mapTypeSatellite ? mapTypeMap : mapTypeSatellite });
                }}
              >
                {mapType === mapTypeSatellite ? translate('map_satellite') : translate('map_map')}
              </Text>
            </View>
          </View>
        </View>
        <View
          style={{
            flex: 1,
          }}
        >
          {/* Inner view that is responsible to get _ON TOP_ of the map */}
          <KeyboardAvoidingView
            style={[{
              backgroundColor: 'white',
              flexDirection: 'column',
              position: 'absolute',
              overflow: 'hidden',
              flex: 1,
            }, direction === 'column' ? {
              top: -mapRadius,
              bottom: 0,
              width: '100%',
              borderTopLeftRadius: mapRadius,
              borderTopRightRadius: mapRadius,
            } : {
              left: -mapRadius,
              right: 0,
              height: '100%',
              borderTopLeftRadius: mapRadius,
              borderBottomLeftRadius: mapRadius,
            }]}
            behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          >
            {status !== undefined && (
              <Text
                style={{
                  color: 'red',
                }}
              >
                {status}
              </Text>
            )}
            <View
              style={{
                flex: 1,
                width: '100%',
              }}
            >
              {/* <ScrollFading
                style={{
                  flex: 1,
                  width: '100%',
                }}
                refreshControl={onRefresh !== undefined ? (
                  <RefreshControl refreshing={refreshing} onRefresh={this.handleRefresh} />
                ) : undefined}
              > */}
              <Text
                style={{
                  marginVertical: 20,
                  marginHorizontal: 40,
                }}
              >
                {translate('pivot_instructions')}
              </Text>
              <View
                style={[{
                  flex: 1,
                  flexDirection: 'row',
                  alignSelf: 'center',
                }, direction === 'column' ? {
                  width: '80%',
                } : {
                  width: '100%',
                }]}
              >
                <SafeAreaView
                  style={[{
                    flex: 1,
                    flexDirection: 'column',
                  }]}
                >
                  {app.pp.legsManual && app.pp.legsManual[index] && (
                    <DraggableFlatList
                      style={{
                        flex: 1,
                        // width: '100%',
                      }}
                      data={app.pp.legsManual[index]}
                      keyExtractor={(leg, _index) => `${leg[0]},${leg[1]}`}
                      ListHeaderComponent={header}
                      ListFooterComponent={footer}
                      renderItem={({
                        item: leg, index: idx, move, moveEnd, isActive,
                      }) => (
                        <TouchableOpacity
                          style={{
                            // width: '100%',
                          }}
                          key={`${leg[0]},${leg[1]},${isActive ? '1' : '0'}`}
                          onLongPress={move}
                          onPressOut={moveEnd}
                        >
                          <PivotPointBadge
                            key={`${leg[0]},${leg[1]}`}
                            idx={idx + 1}
                            point={{
                              name: `${leg[0]}, ${leg[1]}`,
                              lat: leg[0],
                              lon: leg[1],
                            }}
                            del
                            onDel={() => {
                              const { legsManual } = app.pp;
                              legsManual[index].splice(idx, 1);
                              setFieldValue('legsManual', compressToBase64(JSON.stringify(legsManual)));
                              setFieldTouched('legsManual');
                            }}
                          />
                        </TouchableOpacity>
                      )}
                      onMoveBegin={(_idx) => {
                        // this.setState({ indexBeingDragged: idx });
                      }}
                      onMoveEnd={({
                        data, _to, _from, _row,
                      }) => {
                        app.pp.legsManual[index] = data;
                        setFieldValue('legsManual', compressToBase64(JSON.stringify(app.pp.legsManual)));
                        setFieldTouched('legsManual');

                        // getAnalyticsService().report.event('page3Reorder', 'create');
                      }}
                    />
                  )}
                </SafeAreaView>
              </View>
              {/* </ScrollFading> */}
            </View>
            <View style={styles.form.containerButtons}>
              <Button
                title={translate('button_cancel')}
                containerStyle={styles.button.secondaryContainer}
                buttonStyle={styles.button.secondary}
                disabledStyle={styles.button.secondaryDisabled}
                titleStyle={styles.button.secondaryTitle}
                disabledTitleStyle={styles.button.secondaryTitleDisabled}
                onPress={() => this.handleCancel(values)}
              />
              {onReset !== undefined && (
                <Button
                  title={translate('button_reset')}
                  containerStyle={styles.button.primaryContainer}
                  buttonStyle={styles.button.primary}
                  disabledStyle={styles.button.primaryDisabled}
                  titleStyle={styles.button.primaryTitle}
                  disabledTitleStyle={styles.button.primaryTitleDisabled}
                  onPress={() => this.handleReset(values)}
                  disabled={!isValid || isSubmitting}
                  loading={isSubmitting}
                  loadingProps={{ size: 'small', color: 'white' }}
                />
              )}
              <Button
                title={endpoint.data.uuid !== 1 ? translate('button_save') : translate('button_add')}
                containerStyle={styles.button.primaryContainer}
                buttonStyle={styles.button.primary}
                disabledStyle={styles.button.primaryDisabled}
                titleStyle={styles.button.primaryTitle}
                disabledTitleStyle={styles.button.primaryTitleDisabled}
                onPress={handleSubmit}
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
                loadingProps={{ size: 'small', color: 'white' }}
              />
            </View>
          </KeyboardAvoidingView>
        </View>
        {(values.workingOnSomething || uploading) && (
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#ffffffc0',
            }}
          >
            <Text
              style={{
                marginVertical: 10,
              }}
            >
              {translate('wait')}
            </Text>
            <ActivityIndicator size="large" color={styles.primaryColor} />
          </View>
        )}
        {isResetting && (
          <Modal
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              alignSelf: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              borderWidth: 0,
            }}
            transparent
            presentationStyle="overFullScreen"
            visible
          >
            <View
              style={{
                flex: 1,
                position: 'relative',
                alignSelf: 'center',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
              }}
            >
              <View
                style={{
                  position: 'relative',
                  alignSelf: 'center',
                  backgroundColor: 'white',
                  padding: 24,
                  paddingBottom: 12,
                  borderColor: styles.primaryColor,
                  borderWidth: 8,
                }}
              >
                <Text>{translate('legs_reset_modal')}</Text>

                <View
                  style={{
                    justifyContent: 'center',
                    flexDirection: 'row',
                    paddingTop: 24,
                  }}
                >
                  <Button
                    title={translate('button_cancel')}
                    containerStyle={styles.button.secondaryContainer}
                    buttonStyle={styles.button.secondary}
                    disabledStyle={styles.button.secondaryDisabled}
                    titleStyle={styles.button.secondaryTitle}
                    disabledTitleStyle={styles.button.secondaryTitleDisabled}
                    onPress={() => { this.setState({ isResetting: false }); }}
                  />
                  <Button
                    title={translate('button_reset')}
                    containerStyle={styles.button.primaryContainer}
                    buttonStyle={styles.button.primary}
                    disabledStyle={styles.button.primaryDisabled}
                    titleStyle={styles.button.primaryTitle}
                    disabledTitleStyle={styles.button.primaryTitleDisabled}
                    onPress={this.handleResetReal}
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    loadingProps={{ size: 'small', color: 'white' }}
                  />
                </View>
              </View>
            </View>
          </Modal>
        )}
      </View>
    );
  };

  render() {
    const {
      app, endpoint, onReset, position,
      index,
    } = this.props;
    const { error } = this.state;

    if (!app
      || !endpoint || !endpoint.data
      || (onReset !== undefined && !endpoint.data)
      || (onReset === undefined && !position)) {
      // console.log('app');
      // console.log(app);
      // console.log('endpoint');
      // console.log(endpoint);
      // console.log('position');
      // console.log(position);
      // console.log('onReset');
      // console.log(onReset);
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    // FIXME(clairbee): why is it needed here? why didn't it work in componentWillReceiveProps?
    app.postProcess();
    // console.log('app');
    // console.log(app);
    endpoint.postProcess();
    // console.log('endpoint');
    // console.log(endpoint);

    if (!app.pp || !app.pp.endpoints || !app.pp.endpoints[index]) {
      console.error('app loaded but invalid');
      console.log('app');
      console.log(app);
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    const { name, extraStay, size } = endpoint.data;
    let { lat, lon } = endpoint.data;

    if (!lat) { lat = position.latitude; }
    if (!lon) { lon = position.longitude; }

    let legsManual;
    if (app.pp.legsManual && index in app.pp.legsManual) {
      legsManual = app.pp.legsManual;
    }
    if (legsManual === undefined) {
      legsManual = {};
    }
    if (legsManual[index] === undefined && app.pp.legs && app.pp.legs.length > index) {
      // console.log('app.pp.legs[index].steps');
      // console.log(app.pp.legs[index].steps);
      legsManual[index] = app.pp.legs[index].steps.slice(1).map((step) => [
        step.start_location.lat,
        step.start_location.lng,
      ]);
    }
    console.log('legsManual');
    console.log(legsManual);

    return (
      <View
        style={{
          flex: 1,
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Formik
          initialValues={{
            error,
            lat,
            lon,
            name: name || '',
            extraStay: extraStay || 0,
            size: size || 0,
            legsManual: compressToBase64(JSON.stringify(legsManual)),
          }}
          enableReinitialize
          validateOnMount
          onSubmit={(values, formikBag) => this.handleSave(values, formikBag)}
          validationSchema={validationSchema}
        >
          {this.renderForm}
        </Formik>
      </View>
    );
  }
}

PublisherLegForm.defaultProps = {
  onReset: undefined,
  position: undefined, // it's unset until it's autodetected
};

PublisherLegForm.propTypes = {
  position: AORTypes.Position,
  app: PropTypes.instanceOf(App).isRequired,
  endpoint: PropTypes.instanceOf(Endpoint).isRequired,
  index: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  getAnalyticsService: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
  // client: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default PublisherLegForm;
